import { useUpdateRmaMutation } from "../../api/api-hooks";
import { RmaItemForm } from "./RmaTypes";

const useLptRmaItemUpdater = () => {
  const [editRma] = useUpdateRmaMutation();
  return (item: RmaItemForm, id: number) => {
    if (
      item.company === null ||
      item.company === undefined ||
      item.hardware === null ||
      item.hardware === undefined
    )
      return { error: { data: { message: "Missing required fields" } } };
    return editRma({
      id: id,
      updateRmaDto: {
        id: id,
        nameId: item.nameId,
        companyId: item.company.id,
        contactName: item.contactName,
        email: item.email,
        phoneNumber: item.phoneNumber,
        hardwareId: Number(item.hardware.id),
        issue: item.issue,
        status: item.status,
        notes: item.notes,
        solution: item.solution,
        shipDate: item.shipDate ? item.shipDate : undefined,
        repairPrice: item.repairPrice ? item.repairPrice : undefined,
        trackingNumber: item.trackingNumber,
        shipper: item.shipper,
        creationDate: item.creationDate ? item.creationDate : undefined,
        isRepaired: !!item.isRepaired,
        orderId: item.order ? item.order.id : null
      },
    });
  };
};

export default useLptRmaItemUpdater;
